module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.24741",
      "conversations-internal-schema": "static-1.12052",
      "head-dlb": "static-1.4360",
      "hs-test-utils": "static-1.7385",
      "hubspot-url-utils": "static-1.3598",
      "HubStyleTokens": "static-2.10907",
      "I18n": "static-7.1461",
      "jasmine-runner": "static-1.5814",
      "quartz": "static-1.6205",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.477",
      "visitor-ui-component-library": "static-1.5552",
      "enviro": "static-4.328",
      "hs-promise-rejection-tracking": "static-1.4750",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "raven-hubspot": "static-1.5536",
      "bend-plugin-trellis-migration": "static-1.2913",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1353",
      "hub-http": "static-1.5499",
      "immutable": "static-2.19",
      "immutable-less": "static-1.3957",
      "quartz-core": "static-1.5424",
      "transmute": "static-2.77",
      "HeadJS": "static-2.628",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.6917",
      "framer-motion": "static-1.54",
      "hs-test-utils-bend-plugin": "static-1.2496",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.136",
      "foundations-theming": "static-1.3732",
      "i18n-data": "static-1.210",
      "metrics-js": "static-1.9140",
      "moment-timezone": "static-5.69",
      "react-utils": "static-2.4771",
      "jasmine": "static-4.3703",
      "quartz-core-utils": "static-1.3072",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.44",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7854",
      "visitor-ui-component-library-icons": "static-1.5363",
      "bender-build-tools": "static-1.2573",
      "rpc-client-utils": "static-1.4088",
      "ts-schema": "static-1.3563",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.122",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.705",
      "hub-http-shared-msw-handlers": "static-1.8547",
      "hubspotter-http": "static-1.4039",
      "hubspotter-http-shared-msw-handlers": "static-1.8545",
      "icons": "static-2.598",
      "mobile-manifest-mixins": "static-1.400",
      "platform-navigation-bootstrap": "static-1.11923",
      "quick-fetch": "static-1.3414",
      "react-rhumb": "static-1.16004",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.335",
      "bend-plugin-foundations-components": "static-1.3186",
      "floating-ui": "static-1.42",
      "foundations-assets": "static-1.4252",
      "foundations-theming-specialty": "static-1.1448",
      "hs-story-utils": "static-1.8767",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.83",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.974",
      "bend-plugin-foundations-theming": "static-1.2215",
      "foundations-theming-base": "static-1.2717",
      "classnames": "static-2.10",
      "cssUtils": "static-1.610",
      "HubStyle": "static-2.11215",
      "sassPrefix": "static-1.143",
      "platform-infra-nav-components": "static-1.7138",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.24741",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12052",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-test-utils": "/hs-test-utils/static-1.7385",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3598",
      "HubStyleTokens": "/HubStyleTokens/static-2.10907",
      "I18n": "/I18n/static-7.1461",
      "jasmine-runner": "/jasmine-runner/static-1.5814",
      "quartz": "/quartz/static-1.6205",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.477",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5552",
      "enviro": "/enviro/static-4.328",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2913",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1353",
      "hub-http": "/hub-http/static-1.5499",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.3957",
      "quartz-core": "/quartz-core/static-1.5424",
      "transmute": "/transmute/static-2.77",
      "HeadJS": "/HeadJS/static-2.628",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.6917",
      "framer-motion": "/framer-motion/static-1.54",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2496",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.136",
      "foundations-theming": "/foundations-theming/static-1.3732",
      "i18n-data": "/i18n-data/static-1.210",
      "metrics-js": "/metrics-js/static-1.9140",
      "moment-timezone": "/moment-timezone/static-5.69",
      "react-utils": "/react-utils/static-2.4771",
      "jasmine": "/jasmine/static-4.3703",
      "quartz-core-utils": "/quartz-core-utils/static-1.3072",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.44",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7854",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5363",
      "bender-build-tools": "/bender-build-tools/static-1.2573",
      "rpc-client-utils": "/rpc-client-utils/static-1.4088",
      "ts-schema": "/ts-schema/static-1.3563",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.122",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.705",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8547",
      "hubspotter-http": "/hubspotter-http/static-1.4039",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8545",
      "icons": "/icons/static-2.598",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.400",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11923",
      "quick-fetch": "/quick-fetch/static-1.3414",
      "react-rhumb": "/react-rhumb/static-1.16004",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.335",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3186",
      "floating-ui": "/floating-ui/static-1.42",
      "foundations-assets": "/foundations-assets/static-1.4252",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1448",
      "hs-story-utils": "/hs-story-utils/static-1.8767",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.83",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.974",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2215",
      "foundations-theming-base": "/foundations-theming-base/static-1.2717",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.610",
      "HubStyle": "/HubStyle/static-2.11215",
      "sassPrefix": "/sassPrefix/static-1.143",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7138",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};